import React, { useEffect, useRef, useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import "../styles/StatsBar.css";

/* ─── individual stat data ──────────────────────── */
const STATS = [
  { icon: "fa-solid fa-users",  num: 5000, suffix: "+", label: "Happy Patients"        },
  { icon: "fa-solid fa-vials",  num: 150,  suffix: "+", label: "Diagnostic Tests"      },
  { icon: "fa-solid fa-award",  num: 10,   suffix: "+", label: "Years of Excellence"   },
  { icon: "fa-solid fa-clock",  num: 24,   suffix: " hrs", label: "Quick Report Delivery" },
];

/* ─── single animated counter ───────────────────── */
const Counter = ({ target, suffix, started }) => {
  const [count, setCount] = useState(0);

  useEffect(() => {
    if (!started) return;

    let start     = 0;
    const duration = 1800;          // ms
    const step      = 16;           // ~60 fps
    const steps     = duration / step;
    const increment = target / steps;

    const timer = setInterval(() => {
      start += increment;
      if (start >= target) {
        setCount(target);
        clearInterval(timer);
      } else {
        setCount(Math.floor(start));
      }
    }, step);

    return () => clearInterval(timer);
  }, [started, target]);

  return (
    <span className="hero-stat-num">
      {count.toLocaleString()}{suffix}
    </span>
  );
};

/* ─── StatsBar ───────────────────────────────────── */
const StatsBar = () => {
  const barRef  = useRef(null);
  const [started, setStarted] = useState(false);

  useEffect(() => {
    const el = barRef.current;
    if (!el) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setStarted(true);
          observer.disconnect();
        }
      },
      { threshold: 0.3 }
    );

    observer.observe(el);
    return () => observer.disconnect();
  }, []);

  return (
    <div className="stats-bar-wrapper" ref={barRef}>
      <Container>
        <div className="stats-bar-card">
          <Row className="g-0 stats-bar-row">
            {STATS.map((stat, i) => (
              <Col key={i} xs={6} md={3} className="stats-bar-col">
                <div className="hero-stat-item">
                  <div className="hero-stat-icon">
                    <i className={stat.icon}></i>
                  </div>
                  <Counter
                    target={stat.num}
                    suffix={stat.suffix}
                    started={started}
                  />
                  <div className="hero-stat-label">{stat.label}</div>
                </div>
                {/* vertical divider — hidden on last col */}
                {i < STATS.length - 1 && (
                  <span className="stats-divider" aria-hidden="true" />
                )}
              </Col>
            ))}
          </Row>
        </div>
      </Container>
    </div>
  );
};

export default StatsBar;